import { getMainMenuItems } from '../../../app/ui/main-menu';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

export const useSearchNavigation = () => {
  const menuItems = getMainMenuItems();
  const navigate = useNavigate();

  return _.flatten(Object.keys(menuItems).slice(0, 2).map((key) => menuItems[key])).map(item => ({
    title: item.label,
    subtitle: item.description,
    icon: item.icon,
    onClick: () => navigate(item.to)
  }));
}
